<template>
    <div
        class="codePress"
        ref="codePress"
        @click="onClickWrap"
    >
        <div
            class="codePress__code"
            :class="{
                'codePress__code--error': isError
            }"
        >
            <input
                v-for="(item, index) in codeArray"
                :key="item.key"
                type="text"
                placeholder="-"
                tabindex="1"
                :data-index="index"
                :data-value="item.value"
                :value="item.value"
                autocomplete="nope"
                @input="onInputCode"
                @keydown="onKeyDownCode"
                @click="onClickInput"
            >
        </div>
        <div
            v-if="isError"
            class="codePress__error"
        >
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    emits: ['update'],
    
    props: {
        code: { type: String, default: '' },
        error: { type: String, default: '' },
    },

    data() {
        return {
            codeArray: [],
        };
    },

    computed: {
        isError() {
            return Boolean(this.error);
        },
    },

    methods: {
        init() {
            if (!this.code) {
                this.codeArray = Array(6).fill('').map((item, index) => ({
                    key: `${item}_${index}`,
                    value: item,
                }));

                return;
            }

            this.codeArray = String(this.code).split('').map((item, index) => ({
                key: `${item}_${index}`,
                value: item,
            }));
        },

        async onKeyDownCode(e) {
            const currentInput = e.target;
            const selectionStart = currentInput.selectionStart;
            const dataIndex = currentInput.getAttribute('data-index');
            const leftButton = e.keyCode === 37;
            const rightButton = e.keyCode === 39;
            const backspaceButton = e.keyCode === 8;
            const endButton = e.keyCode === 35;
            const startButton = e.keyCode === 36;

            const setStep = async (index, selectStart = 0, status = false) => {
                const input = currentInput.parentElement.children[index];

                if (input) {
                    await this.$delay(1);

                    if (status) input.value = '';

                    this.handleChangeCode(input, false);

                    input.focus();
                    input.selectionStart = selectStart;
                }
            };

            if (selectionStart === 1 && backspaceButton) await setStep(Number(+dataIndex - 1), 1);
            if (selectionStart === 0 && backspaceButton) await setStep(Number(+dataIndex - 1), 0, true);
            if (leftButton) await setStep(Number(+dataIndex - 1), 1);
            if (rightButton) await setStep(Number(+dataIndex + 1), 1);
            if (endButton) await setStep(5, 1);
            if (startButton) await setStep(0, 0);
        },

        async onInputCode(e) {
            const currentInput = e.target;

            this.handleChangeCode(currentInput, e);
        },

        handleChangeCode(currentInput, update = true) {
            let value = currentInput.value;
            const dataValue = currentInput.getAttribute('data-value');
            const dataIndex = currentInput.getAttribute('data-index');

            if (isNaN(+value)) value = currentInput.value = dataValue;
            if (value.length === 6) {
                const valueArray = value.split('');

                valueArray.forEach((number, index) => {
                    const input = currentInput.parentElement.children[index];

                    if (input) {
                        const index = input.getAttribute('data-index');
                        input.value = number;
                        input.setAttribute('data-value', number);
                        this.codeArray[index].value = number;
                        input.focus();
                    }
                });
            } else if (value.length > 1) {
                const valueArray = value.split('');
                let input = currentInput;

                valueArray.forEach(number => {
                    if (input) {
                        const index = input.getAttribute('data-index');
                        input.value = number;
                        input.setAttribute('data-value', number);
                        this.codeArray[index].value = number;
                        input.focus();
                        input = input.nextSibling;
                    }
                });
            } else {
                currentInput.setAttribute('data-value', value);
                this.codeArray[dataIndex].value = value;
            }

            const code = this.codeArray.map(i => i.value).join('');

            if (code.length && update) {
                this.$emit('update', {
                    ready: code.length === 6,
                    code: code,
                });
            }
        },

        onClickWrap(e) {
            e.stopPropagation();

            if (this.$refs.codePress) {
                this.$refs.codePress.children[0].focus();
            }
        },

        onClickInput(e) {
            e.stopPropagation();
        },
    },

    mounted() {
        this.init();
    }
};
</script>
